import { captureMessage } from 'works/legacy/lib/sentry';

import { getMatchSamplesEnabled } from './flag-source';
import type { MomentOpType } from './metrics';
import type { DomainNameType } from './subdomains';

// Default 1-in-1000. The wrapper-build PR's environment configuration can
// flip this constant without touching any call site. Sensitive-area domains
// that want denser sampling raise it via a future per-domain override; for
// the scaffold a single global default is enough.
export const SAMPLE_RATE = 1 / 1000;

export type ShadowMatchSampleType = {
  domain: DomainNameType;
  subdomain: string;
  op: MomentOpType;
  /** Moment method whose output was compared (e.g. 'format'). */
  method: string;
  inputFingerprint: string;
  /** Serialized runShadow inputs — kept in parity with the mismatch payload. */
  inputs: string;
  momentOutput: string;
  dayjsOutput: string;
};

export function sendMatchSample(sample: ShadowMatchSampleType): void {
  if (!getMatchSamplesEnabled()) return;
  if (Math.random() >= SAMPLE_RATE) return;

  captureMessage('moment_shadow.match.sample', {
    level: 'info',
    tags: {
      domain: sample.domain,
      subdomain: sample.subdomain,
      op: sample.op,
      method: sample.method,
    },
    extra: {
      inputFingerprint: sample.inputFingerprint,
      inputs: sample.inputs,
      momentOutput: sample.momentOutput,
      dayjsOutput: sample.dayjsOutput,
      ts: new Date().toISOString(),
    },
  });
}
